import Logo from "../../App/Assets/Images/logo.svg";
import React from "react";

interface BrandProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  className?: string;
}

const Brand = ({ className, ...props }: BrandProps) => {
  return <img src={Logo} alt="Appsmen logo" className={className} {...props} />;
};

export default Brand;
